// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var ConversationParticipantsDisplay = require("./ConversationParticipantsDisplay.bs.js");
var ConversationPageSelectedConversationHeader_conversation_graphql = require("../../../__generated__/ConversationPageSelectedConversationHeader_conversation_graphql.bs.js");

var convertFragment = ConversationPageSelectedConversationHeader_conversation_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageSelectedConversationHeader_conversation_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationHeader_conversation_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationPageSelectedConversationHeader_conversation_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageSelectedConversationHeader_conversation_graphql.node, convertFragment, fRef);
}

var ConversationFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ConversationPageSelectedConversationHeader(props) {
  var conversation = use(props.conversation);
  var match = conversation.conversationParticipants;
  if (match !== undefined) {
    return JsxRuntime.jsx(ConversationParticipantsDisplay.make, {
                participantsConnection: match.fragmentRefs,
                showNames: true
              });
  } else {
    return null;
  }
}

var make = ConversationPageSelectedConversationHeader;

exports.ConversationFragment = ConversationFragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
